module.exports = __webpack_public_path__ + "img/inst-modal-7.ffd6f5d4.png";